const text = value => value === null || value === undefined ? '' : String(value);

function node(doc, tag, value = '', className = '') {
  const element = doc.createElement(tag);
  if (className) element.className = className;
  if (value) element.textContent = text(value);
  return element;
}

function resolvePreviewAssetUrl(fileUrl) {
  if (!fileUrl) return '';
  try {
    return new URL(fileUrl, window.location.href).href;
  } catch {
    return String(fileUrl);
  }
}

function appendFacts(doc, root, facts = []) {
  const list = node(doc, 'dl', '', 'facts');
  for (const fact of facts) {
    const row = node(doc, 'div', '', 'fact');
    row.append(node(doc, 'dt', fact?.label), node(doc, 'dd', fact?.value));
    list.append(row);
  }
  root.append(list);
}

function appendTable(doc, root, item) {
  const wrapper = node(doc, 'div', '', 'table-wrap');
  const table = node(doc, 'table');
  const header = node(doc, 'tr');
  for (const column of item.columns || []) header.append(node(doc, 'th', column.label || column.key));
  table.append(header);
  for (const row of item.rows || []) {
    const tr = node(doc, 'tr');
    for (const column of item.columns || []) tr.append(node(doc, 'td', row?.[column.key]));
    table.append(tr);
  }
  wrapper.append(table);
  root.append(wrapper);
}

function appendItem(doc, root, item) {
  const section = node(doc, 'section', '', 'item');
  section.append(node(doc, 'h2', item.title || item.caption || '章节内容'));
  if (item.type === 'text') section.append(node(doc, 'p', item.text));
  if (item.type === 'list') {
    const list = node(doc, 'ul');
    for (const entry of item.entries || []) list.append(node(doc, 'li', entry));
    section.append(list);
  }
  if (item.type === 'facts') appendFacts(doc, section, item.facts);
  if (item.type === 'table') appendTable(doc, section, item);
  if (item.type === 'image') {
    const image = node(doc, 'img');
    image.src = resolvePreviewAssetUrl(item.fileUrl);
    image.alt = item.title || item.caption || '项目成果图';
    section.append(image);
  }
  const note = item.caption || item.note;
  if (note) section.append(node(doc, 'p', note, 'caption'));
  root.append(section);
}

function installStyles(doc) {
  const style = node(doc, 'style');
  style.textContent = `
    :root{font-family:Inter,"PingFang SC","Microsoft YaHei",system-ui,sans-serif;color:#172423;background:#f3f6f5}
    *{box-sizing:border-box}body{margin:0}.cover,.chapter{width:min(1120px,calc(100% - 40px));min-height:calc(100vh - 40px);margin:20px auto;padding:64px 72px;background:#fff;border:1px solid #dde6e4;border-radius:16px}
    .cover{display:grid;align-content:center;color:#eaf5f3;background:#0f2828}.cover h1{margin:16px 0;font-size:clamp(42px,7vw,78px)}.cover p{color:#b8cbca;font-size:20px}.brand{color:#6fd4c8;font-weight:700;letter-spacing:.08em}
    .chapter>header{padding-bottom:22px;border-bottom:1px solid #dde6e4}.ordinal{color:#0b7577;font-weight:700}.chapter h1{margin:8px 0 0;font-size:38px}.item{padding:32px 0;border-bottom:1px solid #edf1f0}.item:last-child{border:0}.item h2{margin:0 0 16px;color:#075a5c}.item p,.item li{line-height:1.75}.item img{display:block;width:100%;max-height:68vh;object-fit:contain;background:#f8faf9;border-radius:12px}
    .facts{margin:0}.fact{display:grid;grid-template-columns:190px 1fr;border-top:1px solid #dde6e4}.fact:last-child{border-bottom:1px solid #dde6e4}.fact dt,.fact dd{padding:12px;margin:0}.fact dt{font-weight:700;background:#e7f4f3}.table-wrap{overflow:auto}table{width:100%;border-collapse:collapse}th,td{padding:11px;border:1px solid #dde6e4;text-align:left;vertical-align:top}th{background:#e7f4f3}.caption{color:#687876;font-size:14px}
    @media(max-width:760px){.cover,.chapter{width:100%;min-height:100vh;margin:0;padding:32px 20px;border:0;border-radius:0}.fact{grid-template-columns:1fr}.chapter h1{font-size:30px}}
    @media print{body{background:#fff}.cover,.chapter{width:100%;height:auto;min-height:100vh;margin:0;border:0;border-radius:0;break-after:page}.item{break-inside:avoid}}
  `;
  doc.head.append(style);
}

export function openReportPreview(documentModel) {
  const preview = window.open('', '_blank');
  if (!preview) throw new Error('浏览器阻止了预览窗口，请允许弹出窗口后重试。');
  preview.opener = null;
  const doc = preview.document;
  doc.title = `${documentModel.project?.name || 'ArchAI'} - 成果预览`;
  doc.documentElement.lang = 'zh-CN';
  installStyles(doc);
  const cover = node(doc, 'section', '', 'cover');
  cover.append(node(doc, 'div', 'ARCHAI 成果汇总', 'brand'));
  cover.append(node(doc, 'h1', documentModel.project?.name || '未命名项目'));
  cover.append(node(doc, 'p', [documentModel.project?.type, documentModel.project?.location].filter(Boolean).join(' / ')));
  doc.body.append(cover);
  const chapters = (documentModel.chapters || []).filter(chapter => chapter.selected);
  chapters.forEach((chapter, index) => {
    const section = node(doc, 'article', '', 'chapter');
    const header = node(doc, 'header');
    header.append(node(doc, 'span', String(index + 1).padStart(2, '0'), 'ordinal'));
    header.append(node(doc, 'h1', chapter.title));
    if (chapter.note) header.append(node(doc, 'p', chapter.note, 'caption'));
    section.append(header);
    (chapter.items || []).filter(item => item.selected).forEach(item => appendItem(doc, section, item));
    doc.body.append(section);
  });
  preview.focus();
  return preview;
}
